<template>
	<div class="centerWidth">
		<!-- <div class="gaokao-nav">
			<span>个人中心 ></span>
			<span>同学关系及师生关系测评 ></span>
			<span>开始测试</span>
		</div> -->
		<section class="gaokao-content">
			<div class="my-title">同学关系及师生关系测评</div>
			<ul class="gkTest-step">
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<img src="../../../image/rel-cla-aa.png" />
							<span>同学关系</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<img src="../../../image/rel-tea-aa.png" />
							<span>师生关系</span>
						</div>
					</div>
				</li>
			</ul>
			<article class="testTwo-con">
				<div class="testTwo-list" v-for="(item,index) in list" :key="index">
					<p class="test-ctxt">{{item.topic}}</p>
					<ul class="testTwo-ul">
						<li v-for="(t,index) in item.option" :key="index">
							<input type="radio" name="sel" />
							<p>{{t.txt}}</p>
						</li>
					</ul>
				</div>
			</article>
			<div class="test-btn">
				<button class="gaokao-btn" @click="goNext()">上一步</button>
				<button class="gaokao-btn">确定</button>
			</div>
		</section>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-if="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isJiaIng: false,
				sel: '',
				list: [{
					topic: '1/80我喜欢看书 ',
					option: [{
						txt: '是'
					}, {
						txt: '否'
					}]
				}, {
					topic: '1/80我喜欢看书',
					option: [{
						txt: '是'
					}, {
						txt: '否'
					}]
				}, {
					topic: '1/80我喜欢看书',
					option: [{
						txt: '是'
					}, {
						txt: '否'
					}]
				}]
			};
		},
		mounted() {
			this.drawLineB();
		},
		methods: {
			drawLineB() {
				const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
				myChart.setOption({
					color: ['#feb9a7', '#3171ff00'],
					tooltip: {
						trigger: 'item',
						show: false
					},
					graphic: {
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: '75%',
							textAlign: 'center',
							fill: '#7ac8fd',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [{
							value: 1048,
							name: ''
						}, {
							value: 735,
							name: ''
						}]
					}]
				});
			},
			// 下一步
			goNext() {
				this.$router.push('/relationa');
			}
		}
	};
</script>

<style scoped>
	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	.test-tit {
		font-size: 16px;
		color: #333;
		position: relative;
		padding-left: 20px;
		margin-bottom: 30px;
	}

	.test-tit::after {
		position: absolute;
		content: '';
		width: 0;
		height: 20px;
		left: 0;
		top: 50%;
		margin-top: -10px;
		border: 2px solid #333;
		border-radius: 50px;
	}

	/* testTwo-con */
	.testTwo-con {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.testTwo-list {
		width: 100%;
		height: auto;
	}

	.test-ctxt {
		font-size: 15px;
		color: #333;
		margin-bottom: 25px;
	}

	.testTwo-ul {
		padding: 0 30px;
		height: auto;
		overflow: hidden;
	}

	.testTwo-ul li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 25px;
	}

	.testTwo-ul li input {
		margin-right: 15px;
	}

	.testTwo-ul li p {
		font-size: 15px;
		color: #333;
	}

	.test-btn {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.test-btn button {
		margin-left: 20px;
		margin-right: 20px;
	}

	.gkTest-step {
		padding: 40px;
		justify-content: center;
	}

	.way-test {
		padding: 0 30px;
		height: auto;
		margin-bottom: 25px;
	}

	.way-test span {
		font-size: 14px;
		color: #333;
		margin-left: 10px;
	}
</style>
